import Login from "./Login";
// import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import Sports from "./Game/Sports";
import ActiveGames from "./Game/ActiveGames";
import SavedGames from "./Game/SavedGames";
import CompletedGames from "./Game/CompletedGames";
import HowToPlay from "./Game/HowToPlay";
import SelectPoint from "./Game/SelectPoint";
import FreePoint from "./Game/FreePoint";
import Payments from "./Game/Payments";
import PaymentsEdit from "./Game/PaymentsEdit";
import Help from "./Help";
import Landing from "./Landing";
// import Play from "./play";
import MyAccount from "./Game/MyAccount";
import Playground from "./Playground";
import PlayReply from "./PlayReply";

const getPlayerNames = (startPos = 0, userName = '', payout = 1) => {
    console.log(payout, 'payout in getPlayerNames func');
    
    let name1 = 'P1'
    let name2 = 'P2'
    let name3 = 'P3'
    let name4 = 'P4'

    if (startPos == 0) {
        name1 = userName;
        
        if (payout == 1) {// 1V4
            name2 = 'P2'
            name3 = 'P3'
            name4 = 'P4'
        } else if (payout == 2) {// 1V1
            name2 = 'P2'
            name3 = '-'
            name4 = '-'
        }
    } else if (startPos == 1) {
        name4 = userName;
        if (payout == 1) {// 1V4
            name1 = 'P2'
            name2 = 'P3'
            name3 = 'P4'
        } else if (payout == 2) {// 1V1
            name1 = 'P2'
            name2 = '-'
            name3 = '-'
        }
    } else if (startPos == 2) {
        name3 = userName;
        if (payout == 1) {// 1V4
            name1 = 'P3'
            name2 = 'P4'
            name4 = 'P2'
        } else if (payout == 2) {// 1V1
            name1 = '-'
            name2 = '-'
            name4 = 'P2'
        }
    } else if (startPos == 3) {
        name2 = userName;
        if (payout == 1) {// 1V4
            name1 = 'P4'
            name3 = 'P2'
            name4 = 'P3'
        } else if (payout == 2) {// 1V1
            name1 = '-'
            name3 = 'P2'
            name4 = '-'
        }
    }

    return {
        name1,
        name2,
        name3,
        name4
    }
}

export {
    Login,
    // Register,
    ForgotPassword,
    // Play,
    MyAccount,
    Playground,
    PlayReply,
    Sports,
    ActiveGames,
    SavedGames,
    CompletedGames,
    HowToPlay,
    SelectPoint,
    FreePoint,
    Payments,
    PaymentsEdit,
    Help,
    Landing,
    getPlayerNames
}